import type {
  EmailBlock,
  EmailBlockData,
} from '@/api/email-builder/email-builder.types.ts';
import { BLOCK_TYPE_META } from '../email-builder.constants';
import { BlockEditor } from './block-editors.component';

interface BlockCardProps {
  block: EmailBlock;
  index: number;
  total: number;
  onUpdate: (id: string, data: EmailBlockData) => void;
  onRemove: (id: string) => void;
  onMove: (id: string, direction: -1 | 1) => void;
}

/** A single block in the editor: header (label, reorder, delete) + its editor. */
export function BlockCard({
  block,
  index,
  total,
  onUpdate,
  onRemove,
  onMove,
}: BlockCardProps) {
  const meta = BLOCK_TYPE_META[block.type];

  return (
    <div className="eb-block-card">
      <div className="eb-block-head">
        <span className="eb-block-index">{index + 1}</span>
        <span className="eb-block-label">{meta.label}</span>
        <div className="eb-block-actions">
          <button
            type="button"
            className="eb-icon-btn"
            title="Nach oben verschieben"
            disabled={index === 0}
            onClick={() => onMove(block.id, -1)}
          >
            ↑
          </button>
          <button
            type="button"
            className="eb-icon-btn"
            title="Nach unten verschieben"
            disabled={index === total - 1}
            onClick={() => onMove(block.id, 1)}
          >
            ↓
          </button>
          <button
            type="button"
            className="eb-icon-btn eb-icon-btn-danger"
            title="Block löschen"
            onClick={() => onRemove(block.id)}
          >
            ✕
          </button>
        </div>
      </div>
      <div className="eb-block-body">
        <BlockEditor
          block={block}
          onChange={(data) => onUpdate(block.id, data)}
        />
      </div>
    </div>
  );
}
